/**
 * Builds a short UTC offset + localized time zone name for an IANA id (browser Intl).
 * Used so time zone dropdown labels follow the active UI locale.
 */
export function formatTimeZoneLabel(ianaId, locale) {
    const now = new Date();
    let offset;
    try {
        offset =
            new Intl.DateTimeFormat("en-US", {
                timeZone: ianaId,
                timeZoneName: "shortOffset",
            })
                .formatToParts(now)
                .find((p) => p.type === "timeZoneName")?.value ?? "";
    }
    catch {
        return ianaId;
    }
    let name = ianaId;
    try {
        name =
            new Intl.DateTimeFormat(locale, {
                timeZone: ianaId,
                timeZoneName: "long",
            })
                .formatToParts(now)
                .find((p) => p.type === "timeZoneName")?.value ?? ianaId;
    }
    catch {
        /* keep ianaId */
    }
    return [offset, name].filter(Boolean).join(" ");
}
export function localizeTimeZoneSelectOptions(options, locale) {
    return options.map((opt) => ({
        value: opt.value,
        label: formatTimeZoneLabel(String(opt.value), locale),
    }));
}
